import { Form, Input } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { emailAsciiRule } from 'app/utils/rules';

import { FieldValue } from '../FieldView/FieldView';

const { TextArea } = Input;

export type ContactFieldConfig = {
  name: string;
  label: string;
  type?: 'text' | 'email' | 'tel';
  multiline?: boolean;
  isRequired?: boolean;
};

type ContactFieldProps = ContactFieldConfig & {
  isEditMode: boolean;
  parent?: string;
};

export const ContactField = ({
  name,
  label,
  type = 'text',
  multiline = false,
  isRequired = false,
  isEditMode,
  parent,
}: ContactFieldProps) => {
  const namePath = parent ? [parent, name] : name;

  const rules = isEditMode
    ? [
        ...(isRequired
          ? [{ required: true, message: `${label} is required` }]
          : []),
        ...(type === 'email' ? [emailAsciiRule] : []),
      ]
    : undefined;

  return (
    <FormLineLayout
      label={label}
      isRequired={isRequired}
      labelOnTop={multiline && isEditMode}
    >
      <Form.Item name={namePath} rules={rules}>
        {isEditMode ? (
          multiline ? (
            <TextArea />
          ) : (
            <Input type={type} />
          )
        ) : (
          <FieldValue />
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
